import {Injectable} from '@angular/core';
import {TextBase} from '@im-ng/text';

/**
 * 다이얼로그 문자열
 *
 * @inheritDoc
 * @see TextBase
 * @deprecated LazyPhraseService 사용
 */
@Injectable({
  providedIn: 'root'
})
export class DialogText extends TextBase {
  override readonly en = {
    createTitle: 'Create',
    createDescription: 'Enter the content to create.',

    updateTitle: 'Update',
    updateDdescription: 'Enter the content to update',

    deleteConfirmTitle: 'Delete',
    deleteConfirmDescription: 'Confirm Delete',
    deleteConfirmMessage: 'Are you sure to delete the selected item?',

    deletesConfirmTitle: 'Deletes Many',
    deletesConfirmDescription: 'Confirm Delete',
    deletesConfirmMessage: 'Are you sure to delete the selected items?',

    $createTitle: 'Create __{{this}}__',
    $createDescription: 'Enter the content to create about the __{{this}}__',

    $updateTitle: 'Update __{{this}}__',
    $updateDescription: 'Enter the content to update about the __{{this}}__',

    $deleteConfirmTitle: 'Delete __{{target}}__',
    $deleteConfirmMessage: 'Are you sure to delete about the {{content}}?',

    $deletesConfirmTitle: 'Delete Many __{{target}}__',
    $deletesConfirmMessage: 'Are you sure to delete the selected {{content}}?',
  };

  override readonly kr = {
    createTitle: '등록',
    createDescription: '새로운 항목을 등록하기 위한 내용을 입력하세요.',

    updateTitle: '수정',
    updateDescription: '선택한 항목을 수정하기 위한 내용을 입력하세요.',

    deleteConfirmTitle: '삭제',
    deleteConfirmDescription: '계속 진행 하려면 예를 누르세요.',
    deleteConfirmMessage: '선택한 항목을 정말 삭제할까요?',

    deletesConfirmTitle: '다중 삭제',
    deletesConfirmDescription: '계속 진행 하려면 예를 누르세요.',
    deletesConfirmMessage: '선택한 항목 들을 정말 삭제할까요?',

    $createTitle: '__{{this}}__ 등록',
    $createDescription: '새로운 {{this}}(을) 등록 합니다.',

    $updateTitle: '__{{this}}__ 수정',
    $updateDescription: '{{this}}(을) 수정 합니다.',

    $deleteConfirmTitle: '__{{target}}__ 삭제',
    $deleteConfirmMessage: '정말 선택한 {{content}}(을) 삭제할까요?',

    $deletesConfirmTitle: '__{{target}}__ 다중 삭제',
    $deletesConfirmMessage: '정말 선택한 {{content}}(을) 삭제할까요?',
  };
}
